import { render, staticRenderFns } from "./ContactBar.vue?vue&type=template&id=a8850aac&scoped=true&"
import script from "./ContactBar.vue?vue&type=script&lang=js&"
export * from "./ContactBar.vue?vue&type=script&lang=js&"
import style0 from "./ContactBar.vue?vue&type=style&index=0&id=a8850aac&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8850aac",
  null
  
)

export default component.exports